import { z } from 'zod';
export const ga4MetricsSchema = z.object({
    sessions: z.number().int().min(0),
    active_users: z.number().int().min(0),
    conversions: z.number().min(0),
    engagement_rate: z.number().min(0).max(1),
});
export const gscQueryRowSchema = z.object({
    query: z.string(),
    clicks: z.number().int().min(0),
    impressions: z.number().int().min(0),
});
export const gscMetricsSchema = z.object({
    clicks: z.number().int().min(0),
    impressions: z.number().int().min(0),
    ctr: z.number().min(0).max(1),
    position: z.number().min(0),
    top_queries: z.array(gscQueryRowSchema).max(10),
});
export function parseStoredGa4Metrics(raw) {
    return ga4MetricsSchema.parse(raw);
}
export function parseStoredGscMetrics(raw) {
    return gscMetricsSchema.parse(raw);
}
//# sourceMappingURL=googleMetrics.js.map